export const sigFigs100 = (value: number) => Math.round(value * 100) / 100
export const wholeNumber = (value: number) => Math.round(value)
